import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import {
  School,
  ApiTermData,
  GetTermApiResponse,
  CreateApplicationPayload,
  CreateApplicationResponse,
  GetApplicationStudentsResponse,
  SchoolDetailsResponse,
  GetDocumentsResponse,
  AddStudentResponse,
  GetApplicationsForActiveTermResponse
} from '../../core/models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class SchoolService {
  private apiUrl = environment.apiUrl;
  private readonly acceptJsonHeaders = new HttpHeaders({
    'Accept': 'application/json'
  });

  private readonly contentAndAcceptJsonHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  });

  constructor(private http: HttpClient) { }
  getAuthenticatedSchoolDetails(): Observable<SchoolDetailsResponse> {
    return this.http.get<SchoolDetailsResponse>(`${this.apiUrl}/getSchool`, { headers: this.acceptJsonHeaders });
  }
  getTerms(): Observable<GetTermApiResponse> {
    return this.http.get<GetTermApiResponse>(`${this.apiUrl}/getTerm`, { headers: this.acceptJsonHeaders });
  }

  createApplication(payload: CreateApplicationPayload): Observable<CreateApplicationResponse> {
    return this.http.post<CreateApplicationResponse>(`${this.apiUrl}/createApplication`, payload, { headers: this.contentAndAcceptJsonHeaders });
  }

  getApplicationStudents(applicationId: number): Observable<GetApplicationStudentsResponse> {
    return this.http.get<GetApplicationStudentsResponse>(`${this.apiUrl}/getApplicationStudents/${applicationId}`, { headers: this.acceptJsonHeaders });
  }

  getDocuments(): Observable<GetDocumentsResponse> {
    return this.http.get<GetDocumentsResponse>(`${this.apiUrl}/getDocuments`, { headers: this.acceptJsonHeaders });
  }
  addApplicationStudent(studentFormData: FormData): Observable<AddStudentResponse> {
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    return this.http.post<AddStudentResponse>(`${this.apiUrl}/addApplicationStudent`, studentFormData, { headers });
  }
  getApplicationsForActiveTerm(): Observable<GetApplicationsForActiveTermResponse> {
    return this.http.get<GetApplicationsForActiveTermResponse>(`${this.apiUrl}/getApplicationForActiveTerm`, { headers: this.acceptJsonHeaders });
  }
}
